import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import { DialogActions, Grid, IconButton, List, ListItem, Tooltip, Typography } from "@material-ui/core";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditTextField from "../../EditArticle/EditTextField";
import { updateArticles } from "../../../store/articles/ArticlesApi";
import EditSelect from "../../EditArticle/EditSelect";
import { setVatOptions } from "../../../store/articles/ArticlesActions";
import EditNumberField from "../../EditArticle/EditNumberField";
import Printgroups from "./Printgroups";
import Menugroups from "./Menugroups";
import EditCheckbox from "../../EditArticle/EditCheckbox";
import { useDialog } from "../../Dialogs/DialogProvider";
import PriceFieldArticle from "./PriceFieldArticle";
import { Close } from "@material-ui/icons";
import { Article } from "../../../store/articles/models/Article";
import { getTagsString } from "../../../store/articles/models/MenuTag";
import Button from "@material-ui/core/Button";
import ArticleBatchEditSelectArticles from "./ArticleBatchEditSelectArticles";
import { Articlegroup } from "../../../store/articles/models/Articlegroup";
import { getPermission } from "../../AuthorizationWrapper";
import { authentications } from "../../../authorization/authorizations";
import Divider from "@material-ui/core/Divider";
import OpeningHours from "../../OpeningHours/OpeningHours";
import { days } from "../../OpeningHours/WeekHours";
import convertToJson from "../../../helper/convertToJson";
import EditColorPicker from "../../EditArticle/EditColorPicker";

const useStyles = makeStyles(() => ({
  listAllergens: {
    display: "flex",
  },
  section: {
    // border: "2px solid black",
    marginBottom: 10,
  },
  section2: {
    // border: "2px solid pink",
    padding: 10,
  },
  rootButton: {
    fontSize: 12,
    padding: 2,
  },
  rootTitle: { marginRight: 40 },
  disabledTitle: { color: "lightgray" },

  rootDialog: { paddingBottom: 0 },
  // rootDialog: { border: "2px solid blue" },
}));

function ArticleDetailsBatchEditDialog(props) {
  const classes = useStyles();
  const [article, setArticle] = React.useState(
    new Article(
      undefined,
      undefined,
      [],
      undefined,
      undefined,
      [],
      "",
      0,
      0,
      0,
      false,
      undefined,
      undefined,
      undefined,
      "",
      { remark: false },
      undefined,
      undefined,
      0,
      0,
      undefined,
      0,
      false,
      '{"00:00":"24:00"}',
      '{"00:00":"24:00"}',
      '{"00:00":"24:00"}',
      '{"00:00":"24:00"}',
      '{"00:00":"24:00"}',
      '{"00:00":"24:00"}',
      '{"00:00":"24:00"}',
      0,
      0,
      0,
      0,
      undefined,
      0,
      undefined,
      null,
      null,
      null,
      null,
      0
    )
  );
  const [, closeDialog] = useDialog();
  const [selectedItems, setSelectedItems] = React.useState([]);

  let fields = [
    { field: "manual_active", authenticationName: "article.manual_active" },
    { field: "price", authenticationName: "article.price" },
    { field: "print_name", authenticationName: "article.print_name" },
    { field: "print_name_2", authenticationName: "article.print_name_2" },
    { field: "pos_name", authenticationName: "article.pos_name" },
    { field: "description", authenticationName: "article.description" },
    { field: "vat_high", authenticationName: "article.vat_high" },
    { field: "weight", authenticationName: "article.weight" },
    { field: "max_n", authenticationName: "article.max_n" },
    { field: "remark", authenticationName: "article.remark" },
    { field: "category", authenticationName: "article.category" },
    { field: "view_only", authenticationName: "article.view_only" },
    { field: "pos_printer_category", authenticationName: "article.pos_printer_category" },
    { field: "handheld_only", authenticationName: "article.handheld_only" },
    { field: "handheld_bg_color", authenticationName: "article.handheld_bg_color" },
    { field: "active", authenticationName: "article.active" },
    { field: "image", authenticationName: "article.image" },
    { field: "orderHours", authenticationName: "article.allergens" },
    { field: "allergenIds", authenticationName: "article.allergens" },
    { field: "printTags", authenticationName: "printgroups" },
    { field: "menu_tags", authenticationName: "menugroups" },
  ];

  fields = fields.filter((field) => getPermission(authentications[field.authenticationName]) === 3);

  const [fieldsToUpdate, setFieldsToUpdate] = React.useState([]);

  const handleCloseDialog = () => {
    if (fieldsToUpdate.length === 0 && selectedItems.length === 0) {
      closeDialog();
    } else {
      const cancel = window.confirm(props.intl.formatMessage({ id: "unsaved_changes_will_be_lost" }));
      if (cancel === true) {
        closeDialog();
      }
    }
  };

  const saveBatchArticles = () => {
    if (fieldsToUpdate.length === 0 || selectedItems.length === 0) {
      window.alert(props.intl.formatMessage({ id: "pick_field_and_article_to_batch_update" }));
    } else {
      const allSelectedArticles = selectedItems.filter((item) => item instanceof Article);
      const selectedArticlegroups = selectedItems.filter((item) => item instanceof Articlegroup);
      selectedArticlegroups.forEach((group) =>
        group.articleIds.forEach((id) => allSelectedArticles.push(articlesStore.articles[id]))
      );

      const articleJSON = convertToJson(article);

      const allArticleFields = Object.keys(articleJSON);

      allArticleFields.forEach((field) => {
        let fieldMustBeDeleted = !fieldsToUpdate.find((fieldToUpdate) => {
          if (fieldToUpdate === field) {
            return true;
          }
          if (fieldToUpdate === "orderHours") {
            if (days.find((day) => day === field)) {
              return true;
            }
          }
          if (fieldToUpdate === "remark") {
            if (field === "meta_json") {
              return true;
            }
          }
          return false;
        });

        if (fieldMustBeDeleted) {
          delete articleJSON[field];
        }
      });

      const newData = [];
      allSelectedArticles.forEach((article) => newData.push(articleJSON));

      updateArticles(articlesStore.merchantId, allSelectedArticles, newData).then(() => closeDialog());
    }
  };

  const addOpeningsHoursToArticle = (newData) => {
    let newArticle = Object.assign(new Article(), article);
    days.forEach((day) => (newArticle[day] = newData[day]));
    setArticle(newArticle);
  };

  return (
    <>
      <DialogTitle classes={{ root: classes.rootDialog }}>
        <IconButton
          onClick={handleCloseDialog}
          color="primary"
          style={{ position: "absolute", top: "8px", right: "8px" }}
        >
          <Close />
        </IconButton>
        <div style={{ display: "flex" }}>
          <Typography variant={"h5"} classes={{ h5: classes.rootTitle }}>
            Batch update
            <span style={{ display: "block", fontSize: 12, fontWeight: "normal" }}>
              {props.intl.formatMessage({ id: "*Only_changed_fields_will_be_updated" })}
            </span>
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent classes={{ root: classes.rootDialog }} key={article.key}>
        <Grid container spacing={1} style={{ marginBottom: 20 }}>
          <Grid item xs={6}>
            <EditSelect
              label
              helperText={props.intl.formatMessage({ id: "select_fields_to_batch-update" })}
              value={fieldsToUpdate}
              optionValues={fields.map((element) => element.field)}
              optionViewValues={fields.map((element) => props.intl.formatMessage({ id: "batch." + element.field }))}
              multiple={true}
              onChange={(value) => {
                setFieldsToUpdate(value);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <ArticleBatchEditSelectArticles setSelectedItems={setSelectedItems} />
          </Grid>
        </Grid>
        <Divider style={{ marginBottom: 20 }} />
        <Grid container>
          <Grid item container xs={12} md={6} alignContent={"flex-start"} spacing={1} className={classes.section2}>
            <Grid item className={classes.section} xs={6}>
              <EditTextField
                disabled
                key={article.key}
                authorizationField={"article.name"}
                label={props.intl.formatMessage({ id: "article_name" })}
                value={article.name == null ? "" : article.name}
                onBlur={(value) => {
                  article.name = value;
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.section} xs={6}>
              <PriceFieldArticle
                disabled={!fieldsToUpdate.some((field) => field === "price")}
                article={article}
                onBlur={(value) => {
                  if (typeof article.meta_json?.originalPrice === "number") {
                    article.meta_json.originalPrice = value;
                  } else {
                    if (value == null) {
                      value = 0;
                    }
                    article.price = value;
                  }
                }}
              />
            </Grid>
            <Grid item className={classes.section} xs={6}>
              <EditTextField
                disabled={!fieldsToUpdate.some((field) => field === "print_name")}
                authorizationField={"article.print_name"}
                label={props.intl.formatMessage({ id: "batch.print_name" })}
                value={article.print_name == null ? "" : article.print_name}
                onBlur={(value) => {
                  if (value === "") {
                    value = null;
                  }
                  article.print_name = value;
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.section} xs={6}>
              <EditTextField
                disabled={!fieldsToUpdate.some((field) => field === "print_name_2")}
                authorizationField={"article.print_name_2"}
                label={props.intl.formatMessage({ id: "batch.print_name_2" })}
                value={article.print_name_2 == null ? "" : article.print_name_2}
                onBlur={(value) => {
                  if (value === "") {
                    value = null;
                  }
                  article.print_name_2 = value;
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.section} xs={6}>
              <EditTextField
                disabled={!fieldsToUpdate.some((field) => field === "pos_name")}
                authorizationField={"article.pos_name"}
                label={props.intl.formatMessage({ id: "batch.pos_name" })}
                value={article.pos_name == null ? "" : article.pos_name}
                onBlur={(value) => (article.pos_name = value)}
                variant={"standard"}
              />
            </Grid>
            {/*<Grid item className={classes.section} xs={5}>*/}
            {/*  <EditPriceTextField*/}
            {/*    disabled={!fieldsToUpdate.some((field) => field === "promotion_price")}*/}
            {/*    variant={"standard"}*/}
            {/*    authorizationField={"article.price"}*/}
            {/*    label={props.intl.formatMessage({ id: "action_price" })}*/}
            {/*    price={typeof article.meta_json?.originalPrice === "number" ? article.price : ""}*/}
            {/*    onBlur={(value) => {*/}
            {/*      let newOriginalPrice = null;*/}
            {/*      let price;*/}
            {/*      if (value > 0) {*/}
            {/*        newOriginalPrice = article.meta_json?.originalPrice*/}
            {/*          ? article.meta_json?.originalPrice*/}
            {/*          : article.price;*/}
            {/*        price = value;*/}
            {/*      } else {*/}
            {/*        price = article.meta_json?.originalPrice;*/}
            {/*      }*/}
            {/*      article.meta_json = { originalPrice: newOriginalPrice };*/}
            {/*      article.price = price;*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</Grid>*/}
            <Grid item className={classes.section} xs={12}>
              <EditTextField
                disabled={!fieldsToUpdate.some((field) => field === "description")}
                multiline
                rowsMax={6}
                authorizationField={"article.description"}
                label={props.intl.formatMessage({ id: "batch.description" })}
                value={article.description == null ? "" : article.description}
                onBlur={(value) => {
                  article.description = value;
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.section} xs={12}>
              <EditTextField
                disabled={!fieldsToUpdate.some((field) => field === "category")}
                multiline
                rowsMax={6}
                authorizationField={"article.category"}
                label={props.intl.formatMessage({ id: "article.category" })}
                value={article.category == null ? "" : article.category}
                onBlur={(value) => {
                  article.category = value;
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.section} xs={6} sm={4}>
              <EditSelect
                disabled={!fieldsToUpdate.some((field) => field === "vat_high")}
                key={article.key}
                authorizationField={"article.vat_high"}
                value={article.vat_high == null ? "" : article.vat_high.toString()}
                optionValues={Object.keys(articlesStore.vatOptions)
                  .sort()
                  .map((vatOption) => vatOption)}
                optionViewValues={Object.keys(articlesStore.vatOptions)
                  .sort()
                  .map((vatOption) => vatOption * 100 + "%")}
                allowUnknown={true}
                onUnknown={(value) => {
                  let articlesVat = { ...articlesStore.vatOptions };
                  articlesVat[value / 100.0] = true;
                  setVatOptions(articlesVat);
                  article.vat_high = value / 100.0;
                }}
                onChange={(value) => {
                  if (value !== "+") {
                    article.vat_high = value;
                  }
                }}
              />
            </Grid>
            <Grid item className={classes.section} xs={6} sm={4}>
              <EditNumberField
                disabled={!fieldsToUpdate.some((field) => field === "weight")}
                authorizationField={"article.weight"}
                label={props.intl.formatMessage({ id: "batch.weight" })}
                value={article.weight == null ? "" : article.weight}
                onBlur={(value) => {
                  article.weight = value;
                }}
                variant={"standard"}
                fullWidth
              />
            </Grid>
            <Grid item className={classes.section} xs={6} sm={4}>
              <EditNumberField
                disabled={!fieldsToUpdate.some((field) => field === "max_n")}
                variant={"standard"}
                authorizationField={"article.max_n"}
                label={"Max N"}
                value={article.max_n == null ? "" : article.max_n}
                onBlur={(value) => {
                  article.max_n = value;
                }}
              />
            </Grid>
            <Grid item className={classes.section} xs={6} sm={8}>
              <EditNumberField
                variant={"standard"}
                disabled={!fieldsToUpdate.some((field) => field === "remark")}
                authorizationField={"article.remark"}
                value={article.meta_json?.remark >= 0 ? article.meta_json.remark : ""}
                label={"max length of " + props.intl.formatMessage({ id: "remark" }) + ", 0 for unlimited"}
                onBlur={(value, setBeginValue) => {
                  setBeginValue(value);
                  if (value < 0) {
                    value = "";
                  }
                  if (!article.meta_json) {
                    article.meta_json = {};
                  }
                  article.meta_json.remark = value === "" ? false : Number.parseInt(value);
                }}
              />
              <EditTextField
                disabled={!fieldsToUpdate.some((field) => field === "pos_printer_category")}
                authorizationField={"article.pos_printer_category"}
                label={props.intl.formatMessage({ id: "article.pos_printer_category" })}
                value={article.pos_printer_category === null ? "" : article.pos_printer_category}
                onBlur={(value) => {
                  if (value === "") {
                    value = null;
                  }
                  article.pos_printer_category = value;
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item xs={4}>
              <EditCheckbox
                disabled={!fieldsToUpdate.some((field) => field === "handheld_only")}
                labelPlacement={"start"}
                color={"primary"}
                authorizationField={"article.handheld_only"}
                value={article.handheld_only}
                label={props.intl.formatMessage({ id: "batch.handheld_only" })}
                onChange={(value) => (article.handheld_only = value)}
              />
            </Grid>
            <Grid item xs={4}>
              <div style={{ margin: 8 }}>
                <Typography>Handheld Background Color</Typography>
                <EditColorPicker
                  key={article.handheld_bg_color}
                  disabled={!fieldsToUpdate.some((field) => field === "handheld_bg_color")}
                  labelPlacement={"start"}
                  color={"primary"}
                  authorizationField={"article.handheld_bg_color"}
                  value={article.handheld_bg_color}
                  label={props.intl.formatMessage({ id: "batch.handheld_bg_color" })}
                  onChange={(value) => (article.handheld_bg_color = value)}
                />
              </div>
            </Grid>
            <Grid item xs={4}>
              <EditCheckbox
                disabled={!fieldsToUpdate.some((field) => field === "active")}
                labelPlacement={"start"}
                authorizationField={"article.active"}
                value={article.active}
                label={props.intl.formatMessage({ id: "batch.active" })}
                onChange={(value) => (article.active = value)}
              />
            </Grid>
            <Grid item xs={4}>
              <EditCheckbox
                disabled={!fieldsToUpdate.some((field) => field === "image")}
                labelPlacement={"start"}
                color={"primary"}
                authorizationField={"article.image"}
                value={article.image}
                label={props.intl.formatMessage({ id: "batch.imagePath" })}
                onChange={(value) => (article.image = null)}
              />
            </Grid>
            <Grid item xs={4}>
              <EditCheckbox
                disabled={!fieldsToUpdate.some((field) => field === "manual_active")}
                labelPlacement={"start"}
                color={"primary"}
                authorizationField={"article.manual_active"}
                value={article.manual_active}
                label={props.intl.formatMessage({ id: "batch.manual_active" })}
                onChange={(value) => (article.manual_active = value)}
              />
            </Grid>
            <Grid item xs={4}>
              <EditCheckbox
                disabled={!fieldsToUpdate.some((field) => field === "view_only")}
                labelPlacement={"start"}
                color={"primary"}
                authorizationField={"article.view_only"}
                value={article.view_only}
                label={props.intl.formatMessage({ id: "batch.view_only" })}
                onChange={(value) => (article.view_only = value)}
              />
            </Grid>
            <Grid item xs={11}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  classes={{ root: !fieldsToUpdate.some((field) => field === "orderHours") && classes.disabledTitle }}
                  style={{ margin: "8px 0" }}
                >
                  {props.intl.formatMessage({ id: "order_hours" })}
                </Typography>
              </div>
              <OpeningHours
                disabled={!fieldsToUpdate.some((field) => field === "orderHours")}
                size="small"
                openingHours={article}
                onSave={(newData) => {
                  addOpeningsHoursToArticle(newData);
                }}
              />
            </Grid>
          </Grid>
          <Grid container xs={12} md={6} spacing={1} className={classes.section2}>
            <Grid item className={classes.section} xs={12}>
              <Typography
                classes={{ root: !fieldsToUpdate.some((field) => field === "allergenIds") && classes.disabledTitle }}
              >
                {props.intl.formatMessage({ id: "batch.allergenIds" })}
              </Typography>
              <div style={{ width: "auto" }}>
                <EditSelect
                  disabled={!fieldsToUpdate.some((field) => field === "allergenIds")}
                  authorizationField={"article.allergens"}
                  value={article.allergenIds}
                  optionValues={Object.keys(articlesStore.allergens).map((allergenId) => parseInt(allergenId))}
                  optionViewValues={Object.keys(articlesStore.allergens).map((allergenId) => {
                    return articlesStore.allergens[allergenId].name;
                  })}
                  multiple={true}
                  onChange={(value) => {
                    article.allergenIds = value;
                  }}
                />
              </div>
              {article.allergenIds.length > 0 ? (
                <List classes={{ root: classes.listAllergens }}>
                  {article.allergenIds.map((allergenId) => (
                    <ListItem
                      key={allergenId}
                      style={{
                        margin: "0 1px 1px 1px",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Tooltip
                        placement={"top"}
                        title={articlesStore.allergens[allergenId].name}
                        style={{ fontSize: "18pt" }}
                      >
                        <img
                          style={{
                            height: "24px",
                            width: "24px",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                          alt={articlesStore.allergens[allergenId].name}
                          src={articlesStore.allergens[allergenId].getImagePath()}
                        />
                      </Tooltip>
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Typography
                  classes={{ root: !fieldsToUpdate.some((field) => field === "allergenIds") && classes.disabledTitle }}
                >
                  Geen allergenen
                </Typography>
              )}
            </Grid>
            <Grid item className={classes.section} xs={12}>
              <Printgroups
                disabled={!fieldsToUpdate.some((field) => field === "printTags")}
                article={article}
                onChange={(value) => {
                  article.tag = getTagsString(value);
                }}
              />
            </Grid>
            <Grid item className={classes.section} xs={12}>
              <Menugroups
                disabled={!fieldsToUpdate.some((field) => field === "menu_tags")}
                article={article}
                onChange={(value) => {
                  article.menu_tags = getTagsString(value);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          style={{ marginRight: "5px" }}
          onClick={() => {
            saveBatchArticles();
          }}
          variant="standard"
        >
          Batch update
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(ArticleDetailsBatchEditDialog);
